export const isRubles = (currency = 'rub') => currency === 'rub';
//# sourceMappingURL=isRubles.js.map